/*
  CUSTOM: "Benachrichtigung erhalten" – Logik zu snippets/benachrichtigung-button.liquid.

  - Sichtbarkeit: Dawn publiziert nach jedem Variantenwechsel PUB_SUB_EVENTS.variantChange mit der
    neuen Variante. Der Block ist nur bei ausverkaufter Variante sichtbar.
  - Speichern: Kunden-Metafeld custom.meine_benachrichtigungen ueber die Customer Account API.
    Login/Token stellt window.WishlistManager (assets/wishlist.js) bereit; wishlist.js selbst bleibt
    unveraendert.
  - Ohne Storefront-Login bzw. ohne Token wird die Vormerkung kurz in localStorage geparkt und nach
    der Rueckkehr auf dieselbe Produktseite automatisch ausgefuehrt (Ruecksprung aus dem Shopify-Login
    bzw. ueber den OAuth-Callback auf /pages/wunschliste).
  - Rueckmeldung nur im Button: Text-Wechsel mit kurzer Animation, Pop beim Eintragen, Wackeln bei
    Fehlern. Abbestellen in zwei Schritten (aktiv -> Rueckfrage -> abbestellt). Fuer Screenreader
    zusaetzlich ein unsichtbarer Status-Bereich.
  Texte kommen aus den data-Attributen des Snippets.
*/

(function () {
  'use strict';
  if (window.__bnRestockInit) return;
  window.__bnRestockInit = true;

  var LIST_KEY = 'meine_benachrichtigungen';
  var MAX_ITEMS = 128;
  var PENDING_KEY = 'bn_pending';
  var PENDING_TTL_MS = 30 * 60 * 1000;
  var CONFIRM_MS = 4000;
  var SUCCESS_MS = 4000;
  var FLASH_MS = 1800;
  var ERROR_MS = 2500;

  var GET_QUERY =
    'query($key: String!) { customer { id metafield(namespace: "custom", key: $key) { value compareDigest } } }';
  var SET_MUTATION =
    'mutation($metafields: [MetafieldsSetInput!]!) { metafieldsSet(metafields: $metafields) { metafields { key } userErrors { field message code } } }';

  /* ---------- Geparkte Vormerkung ---------- */

  function readPending() {
    try {
      var p = JSON.parse(localStorage.getItem(PENDING_KEY) || 'null');
      if (p && Date.now() - p.ts <= PENDING_TTL_MS) return p;
      localStorage.removeItem(PENDING_KEY);
    } catch (e) {}
    return null;
  }

  function writePending(p) {
    try {
      localStorage.setItem(PENDING_KEY, JSON.stringify(p));
    } catch (e) {}
  }

  function clearPending() {
    try {
      localStorage.removeItem(PENDING_KEY);
    } catch (e) {}
  }

  /* ---------- Customer Account API ---------- */

  function getManager(root) {
    var wm = window.WishlistManager;
    if (!wm) return null;
    if (!wm._ready) {
      wm.init({
        shopId: root.dataset.shopId,
        clientId: root.dataset.clientId,
        customerId: root.dataset.customerId,
        callbackUrl: root.dataset.callbackUrl,
      });
    }
    return wm._ready ? wm : null;
  }

  async function updateList(wm, variantId, add) {
    var gid = 'gid://shopify/ProductVariant/' + variantId;

    // Zweiter Versuch, falls die Liste parallel geaendert wurde (compareDigest veraltet).
    for (var attempt = 0; attempt < 2; attempt++) {
      var res = await wm._apiCall(GET_QUERY, { key: LIST_KEY });
      var customer = res && res.data && res.data.customer;
      if (!customer) return false;

      var mf = customer.metafield;
      var items = mf && mf.value ? JSON.parse(mf.value) : [];
      var has = items.indexOf(gid) !== -1;
      if (add === has) return true;

      if (add) {
        items.push(gid);
        if (items.length > MAX_ITEMS) items = items.slice(items.length - MAX_ITEMS);
      } else {
        items = items.filter(function (id) {
          return id !== gid;
        });
      }

      var input = {
        ownerId: customer.id,
        namespace: 'custom',
        key: LIST_KEY,
        type: 'list.variant_reference',
        value: JSON.stringify(items),
      };
      if (mf && mf.compareDigest) input.compareDigest = mf.compareDigest;

      var out = await wm._apiCall(SET_MUTATION, { metafields: [input] });
      var payload = out && out.data && out.data.metafieldsSet;
      if (payload && payload.userErrors.length === 0) return true;
      console.error('[Benachrichtigung] Speichern fehlgeschlagen:', payload ? payload.userErrors : out);
    }
    return false;
  }

  /* ---------- Block ---------- */

  function initBlock(root) {
    var d = root.dataset;
    var button = root.querySelector('.bn-restock__button');
    var label = root.querySelector('.bn-restock__label');
    var status = root.querySelector('.bn-restock__status');
    var timer = null;
    var known = new Set(
      (d.subscribed || '').split(',').filter(function (id) {
        return id !== '';
      })
    );

    function ruhezustand() {
      return known.has(String(d.variantId)) ? 'active' : 'idle';
    }

    function neustarten(element, klasse) {
      element.classList.remove(klasse);
      void element.offsetWidth; // CSS-Animation erneut abspielen
      element.classList.add(klasse);
    }

    function ansagen(text) {
      status.textContent = '';
      window.setTimeout(function () {
        status.textContent = text || '';
      }, 50);
    }

    // state: 'idle' | 'active' | 'confirm' | 'loading'; text ersetzt kurzzeitig den Standardtext.
    function setState(state, text) {
      window.clearTimeout(timer);
      d.state = state;
      button.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
      if (d.customerId) {
        button.setAttribute('aria-pressed', state === 'active' || state === 'confirm' ? 'true' : 'false');
      }
      var standard =
        state === 'active'
          ? d.textActive
          : state === 'confirm'
          ? d.textConfirm
          : state === 'loading'
          ? d.textLoading
          : d.customerId
          ? d.textIdle
          : d.textGuest;
      label.textContent = text || standard;
      neustarten(label, 'bn-restock__label--neu');
    }

    function kurzZeigen(text, ms) {
      setState(d.state, text);
      timer = window.setTimeout(function () {
        setState(d.state);
      }, ms);
    }

    function fehler() {
      setState(ruhezustand());
      kurzZeigen(d.textError, ERROR_MS);
      neustarten(button, 'bn-restock__button--fehler');
      ansagen(d.sayError);
    }

    async function run(variantId, add, fromLogin) {
      var wm = getManager(root);
      if (!wm) {
        fehler();
        return;
      }
      setState('loading');

      var ok = false;
      try {
        ok = await updateList(wm, variantId, add);
      } catch (e) {
        console.error('[Benachrichtigung]', e);
      }

      if (!ok && !wm.hasToken()) {
        // Token abgelaufen und nicht erneuerbar: einmal neu verbinden, danach geht es hier weiter.
        writePending({ variantId: variantId, add: add, path: location.pathname, ts: Date.now(), authTried: true });
        wm.initiateAuth(null);
        return;
      }

      if (ok) {
        if (add) known.add(String(variantId));
        else known.delete(String(variantId));
      }
      setState(ruhezustand());
      if (String(d.variantId) !== String(variantId)) return;

      if (fromLogin) root.scrollIntoView({ block: 'center', behavior: 'smooth' });
      if (!ok) {
        fehler();
      } else if (add) {
        neustarten(button, 'bn-restock__button--pop');
        kurzZeigen(d.textSuccess, SUCCESS_MS);
        ansagen(d.sayActive);
      } else {
        kurzZeigen(d.textRemoved, FLASH_MS);
        ansagen(d.sayRemoved);
      }
    }

    function start(variantId, add) {
      var pending = { variantId: variantId, add: add, path: location.pathname, ts: Date.now() };

      if (!d.customerId) {
        // Nicht eingeloggt: erst zum Shopify-Login, danach zurueck auf genau diese Variante.
        writePending(pending);
        var back = location.pathname + '?variant=' + encodeURIComponent(variantId);
        var loginUrl = new URL(d.loginUrl, location.origin);
        if (loginUrl.pathname.indexOf('/customer_authentication/') === 0) {
          // Neue Kundenkonten: Ruecksprung nur ueber /customer_authentication/login?return_to=<relativer Pfad>
          loginUrl.pathname = '/customer_authentication/login';
          loginUrl.searchParams.set('return_to', back);
        } else {
          loginUrl.searchParams.set('return_url', back);
        }
        setState('loading');
        location.href = loginUrl.toString();
        return;
      }

      var wm = getManager(root);
      if (wm && !wm.hasToken()) {
        // Eingeloggt, aber noch kein Zugriffstoken: kurzer (meist unsichtbarer) Umweg ueber Shopify.
        pending.authTried = true;
        writePending(pending);
        setState('loading');
        wm.initiateAuth(null);
        return;
      }
      run(variantId, add, false);
    }

    function resume() {
      var p = readPending();
      if (!p || p.path !== location.pathname || !d.customerId) return;

      var wm = getManager(root);
      if (!wm) return;
      if (!wm.hasToken()) {
        if (p.authTried) {
          clearPending();
          fehler();
          return;
        }
        p.authTried = true;
        writePending(p);
        setState('loading');
        wm.initiateAuth(null);
        return;
      }
      clearPending();
      run(String(p.variantId), p.add, true);
    }

    button.addEventListener('click', function () {
      if (d.state === 'loading') return;
      if (d.state === 'active') {
        // Erster Tipp auf "aktiv": Rueckfrage im Button, ohne zweiten Tipp zurueck auf "aktiv".
        setState('confirm');
        ansagen(d.sayConfirm);
        timer = window.setTimeout(function () {
          if (d.state === 'confirm') setState('active');
        }, CONFIRM_MS);
        return;
      }
      start(d.variantId, d.state !== 'confirm');
    });

    function applyVariant(variant) {
      d.variantId = String(variant.id);
      root.classList.toggle('hidden', !!variant.available);
      if (d.state !== 'loading') setState(ruhezustand());
    }

    // Sofort beim Umschalten (ohne auf Dawns Nachladen zu warten). Dawn registriert seinen
    // change-Listener im Konstruktor, currentVariant ist hier also schon aktuell.
    var picker = document.querySelector(
      'variant-selects[data-section="' + d.section + '"], variant-radios[data-section="' + d.section + '"]'
    );
    if (picker) {
      picker.addEventListener('change', function () {
        if (picker.currentVariant) {
          applyVariant(picker.currentVariant);
        } else {
          // Kombination gibt es nicht: Dawns Button ("Nicht verfügbar") wieder zeigen.
          root.classList.add('hidden');
        }
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.variant) return;
        if (data.sectionId && data.sectionId !== d.section) return;
        applyVariant(data.variant);
      });
    }

    resume();
  }

  function init() {
    document.querySelectorAll('.bn-restock').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
